module.exports = __webpack_public_path__ + "img/cwell9.c56aec5b.jpg";